module.exports = __webpack_public_path__ + "img/title.16441926.png";